import React, { FC } from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://toastie.au';
const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/toastie-logo.png`;

interface SEOProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  jsonLd?: object[];
}

export const SEO: FC<SEOProps> = ({ title, description, path, ogImage, jsonLd = [] }) => {
  const canonicalUrl = `${SITE_URL}${path === '/' ? '' : path}`;
  const image = ogImage ?? DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};
